<template>
  <main>
    <Header />
    <div class="title">
      <h1 v-bind:style="styleH1" ref="h1" v-html="titre"></h1>
    </div>
    <div class="views" ref="view">
      <section v-bind:style="marginSection">
        <ul class="projList">
          <li>
            <router-link to="/fedexsoundtrack">
              <b>FedEx Soundtrack</b><span>Campagne Web (USA)</span>
            </router-link>
          </li>
          <li>
            <router-link to="/kinder">
              <b>Kinder .com</b><span>Site vitrine (monde)</span>
            </router-link>
          </li>
          <li>
            <router-link to="/heinekenthesub">
              <b>Heineken The Sub</b><span>Site e-commerce (EU)</span>
            </router-link>
          </li>
          <li>
            <router-link to="/frico">
              <b>Frico .com</b><span>Site vitrine (EU)</span>
            </router-link>
          </li>
          <li>
            <router-link to="/adidas">
              <b>Adidas</b><span>Intranet (EU)</span>
            </router-link>
          </li>
          <li>
            <router-link to="/jeudecartesux">
              <b>Jeu de Cartes UX</b><span>Outils UX (WORKSHOP)</span>
            </router-link>
          </li>

          <li>
            <router-link to="/araymond">
              <b>Araymond – Raybond</b><span>CRM/Intranet (FR)</span>
            </router-link>
          </li>
          <li>
            <router-link to="/tablerondefrancaise">
              <b>La Table Ronde Française</b><span>AO – Site vitrine (FR)</span>
            </router-link>
          </li>
          <li>
            <router-link to="/opalines">
              <b>Les Opalines (ADMR)</b><span>AO – CRM/Intranet (FR)</span>
            </router-link>
          </li>
        </ul>
      </section>
    </div>
    <transition name="next">
      <router-link class="next" v-if="next" to="/expertise"
        >À Propos</router-link
      >
    </transition>
    <div class="bgColor"></div>
  </main>
</template>
<script>
import Header from "@/components/header.vue";
export default {
  components: {
    Header
  },
  data() {
    return {
      titre: "Sr. UX<b>&</b>UI Designer à Chambéry, Savoie.",
      marginSection: {
        marginTop: "0px",
        marginBottom: "0px"
      },
      styleH1: {
        transform: "translateX(0px)",
        opacity: "1"
      },
      next: false
    };
  },
  methods: {
    handleScroll() {
      var ph = this.$refs.view.offsetHeight - window.innerHeight;
      var s = window.scrollY;

      if (ph <= Math.round(s)) {
        this.$data.next = true;
      } else {
        this.$data.next = false;
      }

      var v = window.innerHeight;
      var mini = v / 2 - 170;
      var maxi = ph - v / 2 + 170;
      var odef = 0.1;

      if (s < mini) {
        var pmin = Math.round((s * 100) / mini);
        var omin = Math.abs(pmin - 100) / 100;
        this.$data.styleH1.opacity = "" + Math.max(odef, omin) + "";
      }
      if (s >= mini && s <= maxi) {
        this.$data.styleH1.opacity = "" + odef + "";
      }
      if (s > maxi) {
        var pmax = Math.round(((s - maxi) * 100) / (ph - maxi));
        var omax = pmax / 100;
        this.$data.styleH1.opacity = "" + Math.max(odef, omax) + "";
      }
    },
    handleMousemove(e) {
      var x = e.clientX;
      var w = this.$parent.$el.offsetWidth;
      var titleW = this.$refs.h1.offsetWidth;
      var p = Math.round((x * 100) / w) / 100;
      var t = p * (titleW - w);

      this.$data.styleH1.transform = "translateX(-" + t + "px)";
    },
    handleResize() {
      this.$data.marginSection.marginTop = (window.innerHeight / 4) * 3 + "px";
      this.$data.marginSection.marginBottom =
        (window.innerHeight / 4) * 3 + "px";
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("mousemove", this.handleMousemove);
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("mousemove", this.handleMousemove);
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
